import { FC } from 'react';
import { Box, Typography, Grid, BoxProps, PaperProps } from '@mui/material';

import ImagePreview from './ImagePreview';


interface ImagePreviewGridProps extends BoxProps {
  files: Tributes.MediaFile[];
  onRemove?: (file: Tributes.MediaFile) => void;
  readonly?: boolean;
  title?: string;
  slotProps?: {
    paper?: PaperProps;
  }
  onViewMedia?: (selectedFileIndex: number) => void;
  selectedFileIndex?: number;
}

const ImagePreviewGrid: FC<ImagePreviewGridProps> = (props) => {
  const { files, onRemove, readonly, title, slotProps, onViewMedia, selectedFileIndex, ...boxProps } = props;
  if (files.length === 0) {
    return null;
  }

  return (
    <Box {...boxProps}>
      {title && <Typography variant="subtitle2" sx={{ mb: 2 }}>{title}</Typography>}
      <Grid container spacing={2}>
        {files.map((file, index) => (
          <Grid key={(file as Tributes.FileWithPreview).name ? (file as Tributes.FileWithPreview).name : (file as Tributes.Media).id}>
            <ImagePreview
              file={file}
              onRemove={onRemove}
              readonly={readonly}
              slotProps={{ paper: slotProps?.paper }}
              onView={() => onViewMedia?.(index)}
              isSelected={selectedFileIndex === index}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ImagePreviewGrid;
